import React from "react";
import Lottie from "react-lottie";
import Loader from "../../assets/lottie-files/loader.json";
import "./index.scss";

const Loading = () => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: Loader,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <div className="loader-container">
      <Lottie options={defaultOptions} height={100} width={100} />
    </div>
  );
};

export default Loading;
